import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Popover,
  TextField,
  Typography,
  Avatar,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useNavigate } from 'react-router-dom';
import { setProjectTypeInStorage } from '../projectTypeUtils';


const ProjectList = ({ list }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [current, setCurrent] = useState({});
  const textRefs = useRef([]);
  const navigate = useNavigate()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    const projectId = localStorage.getItem('project_id');
    if (list.length) {
      setFilteredData(list);
      if (!projectId) {
        localStorage.setItem('project_id', list[0].id);
        window.location.reload();
      }
    }
    if (projectId && list.length) {
      const value = list.find((item) => item?.id === parseInt(projectId));
      setCurrent(value);
      if (value) {
        setProjectTypeInStorage(value);
      }
    } else {
      if(list?.length) {
        localStorage.setItem('project_id', list[0].id);
        setCurrent(list?.[0]);
        if (list?.[0]) {
          setProjectTypeInStorage(list?.[0]);
        }
      }
    }
  }, [list]);

  const handleClickList = (index, item) => {
    localStorage.setItem('project_id', item.id);
    setProjectTypeInStorage(item);
    navigate("/")
    window.location.reload();
    handleClose();
  };

  const getProjectList = () => (
    <Box maxHeight={400} overflow="auto" px={1}>
      {filteredData.map((item, index) => (
        <Box
          key={index}
          ref={(el) => (textRefs.current[index] = el)}
          onClick={() => handleClickList(index, item)}
          sx={{
            maxWidth: 240,
            px: 1,
            py: 0.5,
            mb: 1,
            mt: index !== 0 ? 0 : 0.5,
            borderRadius: 1,
            fontWeight: current?.id === item.id ? 600 : 400,
            cursor: 'pointer',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            fontSize: '16px',
            color: current?.id === item.id ? '#fff' : '#000',
            backgroundColor: current?.id === item.id ? '#f16253' : 'transparent',
            '&:hover': {
              backgroundColor: '#f16253',
              color: '#fff',
              fontWeight: 600,
            },
          }}
        >
          {item.name}
        </Box>
      ))}
    </Box>
  );

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = list.filter((project) =>
      project.name.toLowerCase().includes(value)
    );
    setFilteredData(value === '' ? list : filtered);
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          px: 2,
          py: 0.5,
          width: 250,
          border: '1px solid #ccc',
          borderRadius: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, overflow: 'hidden' }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: 'transparent',
              // border: `1px solid #f16253`,
              color: 'primary.main',
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            {current?.name?.charAt(0)}
          </Avatar>
          <Box sx={{ overflow: 'hidden' }}>
            <Typography fontWeight="500" fontSize="16px" noWrap>{current?.name}</Typography>
            <Typography fontSize="12px" color="text.secondary" noWrap>
              {current?.project_number}
            </Typography>
          </Box>
        </Box>
        <IconButton size="small">
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        sx={{ mt: 1 }}
      >
        <Box sx={{ width: 260, p: 1, fontSize: '16px' }}>
          <TextField
            fullWidth
            size="small"
            value={searchTerm}
            placeholder="Search project..."
            onChange={handleSearch}
          />
          {getProjectList()}
        </Box>
      </Popover>
    </>
  );
};

export default ProjectList;
